<div class="header-container header-width b3Background" [ngClass]="isBusinessDoctors ? 'b3Background' : 'b2Background'">
    <div class="cnt-row">
        <div (click)="goToLanding()" [ngClass]="isBusinessDoctors ? 'business-doctors-logo-container' : 'new-brixx-logo-container'"></div>
        <!--<p (click)="goToLanding()" class="text-logo-font-size text-logo-offset landing-font white-color" i18n>Model the future</p>-->
    </div>
    <div class="language-container"><app-language-switcher></app-language-switcher></div>
    <!--<simple-btn class="header-back-button"
                [text]="headerButtonText"
                data-testid="GoBackButton"
                (click)="goToLanding()"
                [textCls]="'large-btn-text-500'"
                [height]="40"
                [width]="120"
                [cornerRadius]="50"
                [backgroundFillCls]="'transparent-background'"
                [hoverFillCls]="'g4Background'"
                [borderWidth]=2
                [borderColorCls]="'g4Border'"
                [hoverBorderColorCls]="'g4Border'"
                [textColorCls]="'g4Color'"
                [hoverTextColorCls]="'white-color'">
    </simple-btn>-->
</div>